import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import CantinaHeader from '../components/cantina/CantinaHeader';
import ProductSearch from '../components/cantina/ProductSearch';
import CartPanel from '../components/cantina/CartPanel';
import CheckoutModal from '../components/cantina/CheckoutModal';
import useCantinaCart from '../hooks/cantina/useCantinaCart';
import useCantinaProducts from '../hooks/cantina/useCantinaProducts';
import useCantinaCheckout from '../hooks/cantina/useCantinaCheckout';

export default function Ventas() {
  const cart = useCantinaCart();
  const products = useCantinaProducts(cart.agregar);

  const checkout = useCantinaCheckout({
    carrito: cart.carrito,
    total: cart.total,
    onSuccess: () => {
      cart.vaciar();
      products.focusSearch();
    },
  });

  useEffect(() => {
    const onKeyDown = (event) => {
      if (
        event.ctrlKey &&
        event.key === 'Enter' &&
        !checkout.abierto &&
        cart.carrito.length > 0
      ) {
        event.preventDefault();
        checkout.abrir();
      }
    };

    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [
    checkout,
    cart.carrito.length,
  ]);

  const increase = (id) => {
    cart.cambiarCantidad(id, 1);
    products.focusSearch();
  };

  const decrease = (id) => {
    cart.cambiarCantidad(id, -1);
    products.focusSearch();
  };

  const remove = (id) => {
    cart.quitar(id);
    products.focusSearch();
  };

  const clear = () => {
    cart.vaciar();
    products.focusSearch();
  };

  return (
    <>
      <Navbar />

      <main className="min-h-screen bg-gradient-to-br from-azul-oscuro to-azul-lago p-4 md:p-8">
        <div className="mx-auto grid max-w-[1500px] gap-6 xl:grid-cols-[minmax(0,1fr)_430px]">
          <section className="min-w-0">
            <CantinaHeader />

            <ProductSearch
              inputRef={products.inputRef}
              busqueda={products.busqueda}
              setBusqueda={products.setBusqueda}
              resultados={products.resultados}
              seleccion={products.seleccion}
              cargando={products.cargando}
              onKeyDown={products.onKeyDown}
              onAdd={products.agregarSeleccionado}
            />
          </section>

          <CartPanel
            carrito={cart.carrito}
            unidades={cart.unidades}
            total={cart.total}
            onIncrease={increase}
            onDecrease={decrease}
            onRemove={remove}
            onClear={clear}
            onPay={checkout.abrir}
          />
        </div>
      </main>

      <CheckoutModal
        abierto={checkout.abierto}
        mediosPago={checkout.mediosPago}
        medioSeleccionado={checkout.medioSeleccionado}
        dividir={checkout.dividir}
        medioSeleccionado2={checkout.medioSeleccionado2}
        monto1={checkout.monto1}
        monto2={checkout.monto2}
        onToggleDividir={checkout.alternarDivision}
        onSelect2={checkout.setMedioSeleccionado2}
        onMonto1Change={checkout.cambiarMonto1}
        onMonto2Change={checkout.cambiarMonto2}
        password={checkout.password}
        procesando={checkout.procesando}
        error={checkout.error}
        total={checkout.total}
        onSelect={checkout.setMedioSeleccionado}
        onPasswordChange={checkout.setPassword}
        onConfirm={checkout.confirmar}
        onClose={checkout.cerrar}
        onSelectByIndex={checkout.seleccionarPorIndice}
      />
    </>
  );
}
